import { t } from '@werk85/prelude';
// Custom URL codec using browser's URL API
export const URLFromString = new t.Type('URLFromString', (u) => u instanceof URL, (u, c) => {
    if (typeof u !== 'string') {
        return t.failure(u, c);
    }
    try {
        // Uses browser's built-in URL constructor
        return t.success(new URL(u));
    }
    catch {
        return t.failure(u, c);
    }
}, url => url.toString());
//# sourceMappingURL=URL.js.map